{
  "version": 1,
  "groups": [
    {
      "label": "Getting started",
      "tours": [
        {
          "tourId": "welcome",
          "name": "Welcome",
          "steps": [
            {
              "element": "[data-tour=\"dashboard-header\"]",
              "imagePath": "images/guides/welcome/step-1.webp",
              "caption": "The Dashboard, the daily command center for what needs attention."
            },
            {
              "element": "[data-tour=\"dashboard-stats\"]",
              "imagePath": "images/guides/welcome/step-2.webp",
              "caption": "The Dashboard's stats row — due, upcoming, and closed deals."
            },
            {
              "element": "[data-tour=\"dashboard-milestones\"]",
              "imagePath": "images/guides/welcome/step-3.webp",
              "caption": "The Dashboard's overdue-and-upcoming milestones feed."
            },
            {
              "element": "[data-tour=\"dashboard-pipeline\"]",
              "imagePath": "images/guides/welcome/step-4.webp",
              "caption": "The Dashboard's pipeline counts, by status."
            },
            {
              "element": "[data-tour=\"dashboard-finances\"]",
              "imagePath": "images/guides/welcome/step-5.webp",
              "caption": "The Dashboard's finances panel — income, expenses, and profit."
            }
          ]
        }
      ]
    },
    {
      "label": "Core workflow",
      "tours": [
        {
          "tourId": "add-client",
          "name": "Add Client",
          "steps": [
            {
              "element": "[data-tour=\"clients-header\"]",
              "imagePath": "images/guides/add-client/step-1.webp",
              "caption": "The CRM page header, with your total contact count."
            },
            {
              "element": "[data-tour=\"clients-add\"]",
              "imagePath": "images/guides/add-client/step-2.webp",
              "caption": "The New Client form, for a name, email, phone, and relationship notes."
            },
            {
              "element": "[data-tour=\"clients-kpi\"]",
              "imagePath": "images/guides/add-client/step-3.webp",
              "caption": "The CRM page's KPI row — clients, commission, anniversaries."
            },
            {
              "element": "[data-tour=\"clients-list\"]",
              "imagePath": "images/guides/add-client/step-4.webp",
              "caption": "The Clients list, with search and filters above each card."
            },
            {
              "element": "[data-tour=\"clients-add-form\"]",
              "imagePath": "images/guides/add-client/step-5.webp",
              "caption": "The New client form, with a Google Contacts search above the name fields — look up an existing contact before typing one in by hand."
            }
          ]
        },
        {
          "tourId": "transaction-manual",
          "name": "Transactions list",
          "steps": [
            {
              "element": "[data-tour=\"transactions-header\"]",
              "imagePath": "images/guides/transaction-manual/step-1.webp",
              "caption": "The Transactions page header, with the List/Board view toggle."
            },
            {
              "element": "[data-tour=\"transactions-add\"]",
              "imagePath": "images/guides/transaction-manual/step-2.webp",
              "caption": "The New Transaction form, for choosing a side and adding the property."
            },
            {
              "element": "[data-tour=\"transactions-kpi\"]",
              "imagePath": "images/guides/transaction-manual/step-3.webp",
              "caption": "The Transactions page's KPI tiles — volume, net, and pipeline."
            },
            {
              "element": "[data-tour=\"transactions-list\"]",
              "imagePath": "images/guides/transaction-manual/step-4.webp",
              "caption": "The Transactions list, grouped by status into collapsible chapters."
            },
            {
              "element": "[data-tour=\"txn-checklists-panel\"]",
              "imagePath": "images/guides/transaction-manual/step-5.webp",
              "caption": "The Client Checklists tab, synced to the client portal."
            },
            {
              "element": "[data-tour=\"txn-netsheet-panel\"]",
              "imagePath": "images/guides/transaction-manual/step-6.webp",
              "caption": "The Seller Net Sheet tab, with scenario cards and totals."
            },
            {
              "element": "[data-tour=\"txn-details-key-dates\"]",
              "imagePath": "images/guides/transaction-manual/step-7.webp",
              "caption": "The Transaction Details tab's Key dates section."
            },
            {
              "element": "[data-tour=\"txn-financials-commission\"]",
              "imagePath": "images/guides/transaction-manual/step-8.webp",
              "caption": "The Financials tab's Commission section — split, cap, and fees on this deal."
            },
            {
              "element": "[data-tour=\"txn-checklist-attach-picker\"]",
              "imagePath": "images/guides/transaction-manual/step-9.webp",
              "caption": "The Client Checklists tab's Attach template picker, with Show all types checked."
            },
            {
              "element": "[data-tour=\"txn-email-token-warning\"]",
              "imagePath": "images/guides/transaction-manual/step-10.webp",
              "caption": "The Email Composer tab's warning strip for fields that resolved blank."
            }
          ]
        },
        {
          "tourId": "transaction-pdf",
          "name": "Transaction form",
          "steps": [
            {
              "element": "[data-tour=\"txn-form-header\"]",
              "imagePath": "images/guides/transaction-pdf/step-1.webp",
              "caption": "The transaction form header, with address, clients, and price."
            },
            {
              "element": "[data-tour=\"txn-form-tabs\"]",
              "imagePath": "images/guides/transaction-pdf/step-2.webp",
              "caption": "The transaction form's tab rail — Overview through Email Composer."
            },
            {
              "element": "[data-tour=\"txn-form-pdf-extract\"]",
              "imagePath": "images/guides/transaction-pdf/step-3.webp",
              "caption": "The Details tab's PDF-extract control."
            },
            {
              "element": "[data-tour=\"txn-form-portal\"]",
              "imagePath": "images/guides/transaction-pdf/step-4.webp",
              "caption": "The Details tab's portal-share control."
            },
            {
              "element": "[data-tour=\"txn-form-contract-review\"]",
              "imagePath": "images/guides/transaction-pdf/step-5.webp",
              "caption": "The contract review panel — Verify badges flag the fields KeyFlow was least sure about; every field stays editable before you apply it."
            }
          ]
        },
        {
          "tourId": "closing-path",
          "name": "Closing path and milestones",
          "steps": [
            {
              "element": "[data-tour=\"txn-form-header\"]",
              "imagePath": "images/guides/closing-path/step-1.webp",
              "caption": "The Overview tab's entry point."
            },
            {
              "element": "[data-tour=\"txn-form-tabs\"]",
              "imagePath": "images/guides/closing-path/step-2.webp",
              "caption": "The Overview tab, the closing path’s command center."
            },
            {
              "element": "[data-tour=\"closing-path-milestones\"]",
              "imagePath": "images/guides/closing-path/step-3.webp",
              "caption": "The closing path's milestone timeline."
            },
            {
              "element": "[data-tour=\"closing-path-add\"]",
              "imagePath": "images/guides/closing-path/step-4.webp",
              "caption": "The Add milestone control, below the standard closing path."
            },
            {
              "element": "[data-tour=\"closing-path-reschedule\"]",
              "imagePath": "images/guides/closing-path/step-5.webp",
              "caption": "The Reschedule control on a milestone row."
            },
            {
              "element": "[data-tour=\"closing-path-custom-modal\"]",
              "imagePath": "images/guides/closing-path/step-6.webp",
              "caption": "The custom milestone dialog, with title, date, and visibility toggle."
            }
          ]
        },
        {
          "tourId": "client-portal",
          "name": "Client Portal setup",
          "steps": [
            {
              "element": "[data-tour=\"txn-form-portal\"]",
              "imagePath": "images/guides/client-portal/step-1.webp",
              "caption": "The Details tab's portal-share control."
            },
            {
              "element": "[data-tour=\"portal-header\"]",
              "imagePath": "images/guides/client-portal/step-2.webp",
              "caption": "The client portal's header, with logo and address."
            },
            {
              "element": "[data-tour=\"portal-agent\"]",
              "imagePath": "images/guides/client-portal/step-3.webp",
              "caption": "The client portal's agent-contact and closing-path timeline column."
            },
            {
              "element": "[data-tour=\"portal-checklists\"]",
              "imagePath": "images/guides/client-portal/step-4.webp",
              "caption": "The client portal's shared-checklists and files column."
            }
          ]
        },
        {
          "tourId": "email-composer",
          "name": "Email Composer",
          "steps": [
            {
              "element": "[data-tour=\"email-composer-template\"]",
              "imagePath": "images/guides/email-composer/step-1.webp",
              "caption": "The template picker on a transaction's Email Composer tab."
            },
            {
              "element": "[data-tour=\"email-composer-preview\"]",
              "imagePath": "images/guides/email-composer/step-2.webp",
              "caption": "The resolved subject and message body, ready to edit."
            },
            {
              "element": "[data-tour=\"email-composer-send\"]",
              "imagePath": "images/guides/email-composer/step-3.webp",
              "caption": "The toolbar's attachment tools and Send email button."
            }
          ]
        }
      ]
    },
    {
      "label": "Financials",
      "tours": [
        {
          "tourId": "expenses",
          "name": "Expenses",
          "steps": [
            {
              "element": "[data-tour=\"expenses-header\"]",
              "imagePath": "images/guides/expenses/step-1.webp",
              "caption": "The Expenses page header, with the date-range filter."
            },
            {
              "element": "[data-tour=\"expenses-add\"]",
              "imagePath": "images/guides/expenses/step-2.webp",
              "caption": "The Expenses page's Add control, for an overhead expense."
            },
            {
              "element": "[data-tour=\"expenses-hero\"]",
              "imagePath": "images/guides/expenses/step-3.webp",
              "caption": "The Expenses page's summary card."
            },
            {
              "element": "[data-tour=\"expenses-per-deal\"]",
              "imagePath": "images/guides/expenses/step-4.webp",
              "caption": "The Expenses page's per-deal cost stack card."
            }
          ]
        },
        {
          "tourId": "income-sources",
          "name": "Income sources",
          "steps": [
            {
              "element": "[data-tour=\"income-header\"]",
              "imagePath": "images/guides/income-sources/step-1.webp",
              "caption": "The Income page header, income at a glance."
            },
            {
              "element": "[data-tour=\"income-kpi\"]",
              "imagePath": "images/guides/income-sources/step-2.webp",
              "caption": "The Income page's KPI row, with the end-of-year projection."
            },
            {
              "element": "[data-tour=\"income-chart\"]",
              "imagePath": "images/guides/income-sources/step-3.webp",
              "caption": "The Income page's monthly chart, with the projection breakdown."
            },
            {
              "element": "[data-tour=\"income-add\"]",
              "imagePath": "images/guides/income-sources/step-4.webp",
              "caption": "The Income page's Add control, for income not tied to a deal."
            }
          ]
        }
      ]
    },
    {
      "label": "Your network",
      "tours": [
        {
          "tourId": "partners-transaction",
          "name": "Business Partners (transaction)",
          "steps": [
            {
              "element": "[data-tour=\"txn-form-header\"]",
              "imagePath": "images/guides/partners-transaction/step-1.webp",
              "caption": "The transaction form header, where partners are tracked."
            },
            {
              "element": "[data-tour=\"txn-form-tabs\"]",
              "imagePath": "images/guides/partners-transaction/step-2.webp",
              "caption": "The transaction form's tabs — partners live in Transaction Details, not a standalone vendor tab."
            },
            {
              "element": "[data-tour=\"txn-form-parties\"]",
              "imagePath": "images/guides/partners-transaction/step-3.webp",
              "caption": "Transaction Details > Parties involved — title company, agent, and lender for this deal."
            }
          ]
        },
        {
          "tourId": "partners-page",
          "name": "Business Partners page",
          "steps": [
            {
              "element": "[data-tour=\"partners-header\"]",
              "imagePath": "images/guides/partners-page/step-1.webp",
              "caption": "The Business Partners page header, with your vendor network."
            },
            {
              "element": "[data-tour=\"partners-add\"]",
              "imagePath": "images/guides/partners-page/step-2.webp",
              "caption": "The Business Partners page's Add control, for a new vendor."
            },
            {
              "element": "[data-tour=\"partners-list\"]",
              "imagePath": "images/guides/partners-page/step-3.webp",
              "caption": "The Business Partners page's roster, Title Companies tab."
            }
          ]
        }
      ]
    },
    {
      "label": "Templates and automation",
      "tours": [
        {
          "tourId": "email-templates",
          "name": "Email templates",
          "steps": [
            {
              "element": "[data-tour=\"templates-header\"]",
              "imagePath": "images/guides/email-templates/step-1.webp",
              "caption": "The Transaction emails tab of the Templates page, with token support explained."
            },
            {
              "element": "[data-tour=\"templates-list\"]",
              "imagePath": "images/guides/email-templates/step-2.webp",
              "caption": "The Transaction emails tab's folder list, organized by transaction type."
            }
          ]
        },
        {
          "tourId": "checklist-templates",
          "name": "Checklist templates",
          "steps": [
            {
              "element": "[data-tour=\"templates-header\"]",
              "imagePath": "images/guides/checklist-templates/step-1.webp",
              "caption": "The Checklists tab of the Templates page."
            },
            {
              "element": "[data-tour=\"templates-list\"]",
              "imagePath": "images/guides/checklist-templates/step-2.webp",
              "caption": "The Checklists tab's folder list, by transaction type."
            },
            {
              "element": "[data-tour=\"checklist-template-editor\"]",
              "imagePath": "images/guides/checklist-templates/step-3.webp",
              "caption": "The Checklist Template editor pane — Transaction type, Target audience, and the outline."
            }
          ]
        },
        {
          "tourId": "message-templates",
          "name": "Message templates",
          "hidden": true,
          "steps": [
            {
              "element": "[data-tour=\"message-templates-header\"]",
              "imagePath": "images/guides/message-templates/step-1.webp",
              "caption": "The Message Templates page header, for plain-text SMS templates."
            },
            {
              "element": "[data-tour=\"message-templates-add\"]",
              "imagePath": "images/guides/message-templates/step-2.webp",
              "caption": "The Message Templates page's Add control, with token placeholders."
            },
            {
              "element": "[data-tour=\"message-templates-list\"]",
              "imagePath": "images/guides/message-templates/step-3.webp",
              "caption": "The Message Templates page's list, with edit, duplicate, and delete."
            }
          ]
        },
        {
          "tourId": "automations",
          "name": "Automations",
          "steps": [
            {
              "element": "[data-tour=\"automations-header\"]",
              "imagePath": "images/guides/automations/step-1.webp",
              "caption": "The Automations page header, for workspace-wide integrations."
            },
            {
              "element": "[data-tour=\"automations-summary\"]",
              "imagePath": "images/guides/automations/step-2.webp",
              "caption": "The Automations page's enabled-count chip."
            },
            {
              "element": "[data-tour=\"automations-grid\"]",
              "imagePath": "images/guides/automations/step-3.webp",
              "caption": "The Automations page's grid."
            },
            {
              "element": "[data-tour=\"automations-calendar-configure\"]",
              "imagePath": "images/guides/automations/step-4.webp",
              "caption": "The Google Calendar Configure modal — connection, event templates, and the milestone checklist."
            }
          ]
        }
      ]
    },
    {
      "label": "Setup and team",
      "tours": [
        {
          "tourId": "settings",
          "name": "Settings and integrations",
          "steps": [
            {
              "element": "[data-tour=\"settings-header\"]",
              "imagePath": "images/guides/settings/step-1.webp",
              "caption": "The Settings page header, for profile, branding, and integrations."
            },
            {
              "element": "[data-tour=\"settings-tabs\"]",
              "imagePath": "images/guides/settings/step-2.webp",
              "caption": "The Settings page's left rail, with autosaving sections."
            }
          ]
        },
        {
          "tourId": "csv-import-export",
          "name": "CSV import/export",
          "steps": [
            {
              "element": "[data-tour=\"settings-csv-export\"]",
              "imagePath": "images/guides/csv-import-export/step-1.webp",
              "caption": "The Settings Data tab's Export control, for a CSV/HTML zip."
            },
            {
              "element": "[data-tour=\"settings-csv-import\"]",
              "imagePath": "images/guides/csv-import-export/step-2.webp",
              "caption": "The Settings Data tab's Import control, which only adds rows."
            }
          ]
        },
        {
          "tourId": "manage-team",
          "name": "Workspace",
          "steps": [
            {
              "element": "[data-tour=\"manage-team-invite\"]",
              "imagePath": "images/guides/manage-team/step-1.webp",
              "caption": "The Workspace page's Invite member card."
            },
            {
              "element": "[data-tour=\"manage-team-roster\"]",
              "imagePath": "images/guides/manage-team/step-2.webp",
              "caption": "The Workspace page's member roster."
            },
            {
              "element": "[data-tour=\"taws-invite\"]",
              "imagePath": "images/guides/manage-team/step-3.webp",
              "caption": "The invite team agent card, on the Team agent tab."
            }
          ]
        }
      ]
    }
  ]
}
